import { rootFontSize } from './viewport';

function setRem() {
  document.documentElement.style.fontSize = rootFontSize(document.documentElement.clientWidth) + 'px';
}

setRem();
window.addEventListener('resize', setRem);
